export const PHONE_CONFIG = {
    'AT': {
        showAreaCodeDropdown: true
    },
    'AU': {
        mask: '00 0000 0000',
        placeholder: '_',
        regex: '^\\d{2} \\d{4} \\d{4}$'
    },
    'BE': {
        showAreaCodeDropdown: true
    },
    'CA': {
        mask: '000-000-0000',
        placeholderChar: '_',
        regex: '^\\d{3}-\\d{3}-\\d{4}$'
    },
    'CH': {
        showAreaCodeDropdown: true
    },
    'CO': {
        mask: '000-000-0000',
        placeholderChar: '_',
        regex: '^\\d{3}-\\d{3}-\\d{4}$'
    },
    'CZ': {
        showAreaCodeDropdown: true
    },
    'DE': {
        mask: '000-0000',
        placeholderChar: '_',
        regex: '^\\d{10,14}$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'DK': {
        showAreaCodeDropdown: true
    },
    'ES': {
        mask: '000000000',
        placeholderChar: '_',
        regex: '^\\d{9}$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'FI': {
        showAreaCodeDropdown: true
    },
    'FR': {
        placeholderChar: '_',
        regex: '^(?:[1-9]\\d{8}|0[1-9]\\d{8})$',
        regex_mobile: '^(?:[679]\\d{8}|0[679]\\d{8})$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'GB': {
        mask: '00000000000',
        placeholderChar: '_',
        regex: '^[0]\\d{10}$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'HU': {
        mask: '000000000',
        placeholderChar: '_',
        regex: '^\\d{9}$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'IE': {
        showAreaCodeDropdown: true
    },
    'IL': {
        showAreaCodeDropdown: true
    },
    'IS': {
        showAreaCodeDropdown: true
    },
    'IT': {
        showAreaCodeDropdown: true
    },
    'JP': {
        regex: '^[\\d]{10,11}$',
    },
    'LU': {
        showAreaCodeDropdown: true
    },
    'MX': {
        mask: '000-000-0000',
        placeholderChar: '_',
        regex: '^\\d{3}-\\d{3}-\\d{4}$'
    },
    'NL': {
        showAreaCodeDropdown: true
    },
    'NO': {
        mask: '00000000',
        placeholderChar: '_',
        regex: '^\\d{8}$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'NZ': {
        mask: '00 0000 0000',
        placeholder: '_',
        regex: '^\\d{2} \\d{4} \\d{4}$'
    },
    'PE': {
        regex: '^\\d{3} \\d{3} \\d{3}$',
        mask: '000 000 000',
        placeholderChar: '_',
        placeholder: 'Phone Number'
    },
    'PL': {
        showAreaCodeDropdown: true
    },
    'PT': {
        showAreaCodeDropdown: true
    },
    'SG': {
        mask: '0000-0000',
        placeholderChar: '_'
    },
    'SK': {
        mask: '000000000',
        placeholderChar: '_',
        showAreaCodeDropdown: true,
        regex: '^\\d{9}$'
    },
    'RO': {
        showAreaCodeDropdown: true
    },
    'RU': {
        showAreaCodeDropdown: true
    },
    'SE': {
        showAreaCodeDropdown: true
    },
    'SK': {
        showAreaCodeDropdown: true
    },
    'TR': {
        showAreaCodeDropdown: true
    },
    'UA': {
        showAreaCodeDropdown: true
    },
    'US': {
        mask: '000-000-0000',
        placeholderChar: '_',
        regex: '^\\d{3}-\\d{3}-\\d{4}$',
        showAreaCodeDropdown: true,
        areaCodeGroup: 'EU'
    },
    'ZA': {
        regex: '^[0]\\d{9}$',
        mask: '\\0000000000',
        placeholderChar: '_'
    }
};
